import React, { useRef, useState, useEffect } from 'react';
import NET from 'vanta/dist/vanta.net.min';

const About = () => {
  const aboutRef = useRef(null);
  const [vantaEffect, setVantaEffect] = useState(null);

  useEffect(
    () => {
      if (!vantaEffect) {
        setVantaEffect(
          NET({
            el: aboutRef.current,
            mouseControls: true,
            touchControls: true,
            gyroControls: false,
            minHeight: 200.00,
            minWidth: 200.00,
            scale: 1.00,
            scaleMobile: 1.00,
            color: '#FF7600',
            backgroundColor: '#0B0928',
            points: 7.00,
            maxDistance: 25.00,
            showDots: false
          })
        )
      }
      return () => {
        if (vantaEffect) vantaEffect.destroy()
      }
    },
    [vantaEffect],
  )

  return (
    <section className="about" id="about" ref={aboutRef}>
      <div className="wrapper">
        <div className="heading">
          <div className="heading-line-1">Hi, I'm <span>Mike</span>.</div>
          <div className="heading-line-2">I'm a Front-End developer.</div>
        </div>

        <div className="about-content">
          <div className="profile">
            <p className="profile-text">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </div>
          <div className="skills">
            <div className="skills-row">
              <div className="skills-item">
                <img src="svg/html-5.svg" alt="" />
                <div className="skills-item-name">HTML</div>
              </div>
              <div className="skills-item">
                <img src="svg/react.svg" alt="" />
                <div className="skills-item-name">REACT</div>
              </div>
              <div className="skills-item">
                <img src="svg/typescript.svg" alt="" />
                <div className="skills-item-name">TYPESCRIPT</div>
              </div>
            </div>
            <div className="skills-row">
              <div className="skills-item">
                <img src="svg/javascript.svg" alt="" />
                <div className="skills-item-name">JAVASCRIPT</div>
              </div>
              <div className="skills-item">
                <img src="svg/css-3.svg" alt="" />
                <div className="skills-item-name">CSS</div>
              </div>
              <div className="skills-item">
                <img src="svg/nextjs.svg" alt="" />
                <div className="skills-item-name">NEXT.JS</div>
              </div>
              <div className="skills-item">
                <img src="svg/sass.svg" alt="" />
                <div className="skills-item-name">SASS</div>
              </div>
            </div>
            <div className="skills-row">
              <div className="skills-item">
                <img src="svg/swift.svg" alt="" />
                <div className="skills-item-name">SWIFT</div>
              </div>
              <div className="skills-item">
                <img src="svg/uikit.svg" alt="" />
                <div className="skills-item-name">UIKit</div>
              </div>
              <div className="skills-item">
                <img src="svg/firebase.svg" alt="" />
                <div className="skills-item-name">FIREBASE</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
